// Generated by GitHub Copilot
import { useTranslation } from 'react-i18next'
import { AuthenticatorAppSection } from './authenticator-app-section.tsx'
import { LinkedAccountsSection } from './linked-accounts-section.tsx'

/** Element id the Security panel's authenticator-app section carries, so a link can point straight at it. */
export const AUTHENTICATOR_APP_SECTION_ID = 'authenticator-app'

/** Element id of the linked-accounts section, where a Microsoft account is connected. */
export const LINKED_ACCOUNTS_SECTION_ID = 'linked-accounts'

/**
 * The user's Security settings: how they sign in. Rendered by both the company-scoped and the
 * company-less settings routes, so it must not depend on a company.
 */
export function SecurityPanel() {
  const { t } = useTranslation('settings')

  return (
    <div className="p-4 overflow-y-auto h-100">
      <h4 className="fw-bold mb-1">{t('security.title')}</h4>
      <p className="text-secondary mb-4">{t('security.description')}</p>
      <div className="d-flex flex-column gap-3" style={{ maxWidth: '48rem' }}>
        <AuthenticatorAppSection id={AUTHENTICATOR_APP_SECTION_ID} />
        <LinkedAccountsSection id={LINKED_ACCOUNTS_SECTION_ID} />
      </div>
    </div>
  )
}

export default SecurityPanel
